import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { securityApi, type ComplianceDashboard } from '../../api/security';

export function ComplianceCenterPage() {
  const [compliance, setCompliance] = useState<ComplianceDashboard | null>(null);
  useEffect(() => { void securityApi.compliance().then(setCompliance); }, []);
  return (
    <div className="mx-auto max-w-6xl p-6">
      <h1 className="text-2xl font-semibold dark:text-slate-100">Compliance Center</h1>
      <Link to="/security" className="mt-2 inline-block text-sm text-indigo-700 hover:underline dark:text-indigo-400">← SOC Hub</Link>
      <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        <div className="rounded-xl border p-4 dark:border-slate-700"><p className="text-sm text-slate-500">Overall Score</p><p className="text-2xl font-semibold">{compliance?.overall_score.toFixed(0) ?? '—'}%</p></div>
        <div className="rounded-xl border p-4 dark:border-slate-700"><p className="text-sm text-slate-500">Status</p><p className="text-2xl font-semibold capitalize">{compliance?.status ?? '—'}</p></div>
      </div>
      <div className="mt-6 space-y-2">{compliance?.assessments.map((a) => (
        <div key={a.framework} className="rounded border px-3 py-2 text-sm dark:border-slate-700">{a.framework}: {a.score.toFixed(0)}% ({a.passed_controls}/{a.total_controls})</div>
      ))}</div>
    </div>
  );
}
